import { useMemo } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import HeroSection from "./components/HeroSection";
import OverviewSection from "./components/OverviewSection";
import EpisodesSection from "./components/EpisodesSection";
import CharactersSection from "./components/CharactersSection";
import AnalysisSection from "./components/AnalysisSection";
import FaqSection from "./components/FaqSection";
import TestimonialsSection from "./components/TestimonialsSection";
import { usePageSeo } from "@/hooks/usePageSeo";
import { episodes, faqs, siteInfo } from "@/mocks/home";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        description:
          "黑料短剧分集介绍、剧情解析与角色介绍一站式整理，帮你捋清人物关系与反转伏笔。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        email: siteInfo.email,
        description: "围绕都市悬疑短剧《黑料短剧》的独立剧情整理与解析站点。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "黑料短剧热门分集介绍",
        itemListElement: episodes.map((ep, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: `${ep.no}《${ep.title}》`,
          description: ep.summary,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.a,
          },
        })),
      },
    ],
    []
  );

  usePageSeo({
    title: "黑料短剧档案馆 | 黑料短剧剧情解析与分集介绍",
    description:
      "黑料短剧档案馆整理黑料短剧分集介绍、剧情解析与角色介绍，人物关系线与故事梗概同步更新，追剧不漏细节。",
    keywords: "黑料短剧,黑料短剧剧情,黑料短剧分集介绍,黑料短剧故事梗概,黑料短剧角色介绍,黑料短剧剧情解析",
    canonicalPath: "/",
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <OverviewSection />
        <EpisodesSection />
        <CharactersSection />
        <AnalysisSection />
        <FaqSection />
        <TestimonialsSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}